import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Button, Grid, Stack, Box } from '@mui/material';

import { tabsData } from './utils/tabsData';
import { inventoryStyles } from './style/style';
import { SET_SELECTED_ITEM } from 'store/actions';
import InventoryTab from './components/Inventory';
import InventoryEmailsTab from './components/Emails';
import { useCustomMediaQuery } from 'hooks/useMediaQuery';

const InventoryEmails = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const selectedTab = useSelector((state) => state.me.selectedItems);
    const classes = inventoryStyles({ isMobileScreen: useCustomMediaQuery('(max-width: 600px)') });

    const changeTab = (tab) => {
        dispatch(SET_SELECTED_ITEM(tab.label));
        navigate(tab.path);
    };

    useEffect(() => {
        const currentPath = location.pathname.split('/inventory-emails/')[1] || 'emails';
        const currentTab = tabsData.find((tab) => tab.path === currentPath);

        if (currentTab && currentTab.label !== selectedTab) {
            dispatch(SET_SELECTED_ITEM(currentTab.label));
        }
    }, [location.pathname, dispatch, selectedTab]);

    const getTabButtonStyle = (tabLabel) => ({
        textTransform: 'none',
        fontSize: '1rem',
        fontWeight: selectedTab === tabLabel ? '600' : '500',
        backgroundColor: selectedTab === tabLabel ? '#CEEFDF' : 'transparent',
        borderRadius: selectedTab === tabLabel ? '3px' : 'none',
        color: selectedTab === tabLabel ? '#0A8C4D' : '#6C727F',
    });

    return (
        <Box>
            <Box padding={1} sx={classes.menuWrapper}>
                <Stack
                    display="flex"
                    flexDirection={{ xs: 'column', md: 'row' }}
                    gap={1}
                    width={{ xs: '100%', md: 'fit-content' }}
                    style={classes.stack}
                    alignItems="center"
                >
                    {tabsData?.map((tab) => (
                        <Grid item key={tab.label} borderRadius={'5px'}>
                            <Button
                                onClick={() => changeTab(tab)}
                                style={getTabButtonStyle(tab.label)}
                                variant={selectedTab === tab.label ? 'contained' : 'text'}
                            >
                                {tab.label}
                            </Button>
                        </Grid>
                    ))}
                </Stack>
            </Box>

            {selectedTab === 'Inventory' && (
                <Grid sx={classes.tabContentWrapper}>
                    <InventoryTab />
                </Grid>
            )}

            {selectedTab === 'Emails' && (
                <Grid sx={classes.tabContentWrapper}>
                    <InventoryEmailsTab />
                </Grid>
            )}
        </Box>
    );
};

export default InventoryEmails;
